import { TokenIcons } from '../../../assets/icons';
import Card from '../../../components/Card';
import { Tokens } from '../../../config/constants';

type PoolSummaryHeaderProps = {
    title: string;
    value: string;
};

const PoolSummaryHeader: React.FC<PoolSummaryHeaderProps> = ({ title, value }) => {
    return (
        <Card className='pool-summary-header'>
            <span className='title'>{title}</span>
            <span className='value'>
                {value} {Tokens.USDC}&nbsp;{TokenIcons[Tokens.USDC]}
            </span>
        </Card>
    );
};

export default PoolSummaryHeader;
